import styles from "./styles.module.scss";
import cx from "classnames";

const Tooltip = ({
    children,
    content,
    arrowPosition = "top",
    className = "",
}) => {
    return (
        <div className={cx(styles["tooltip-container"], className)}>
            {children}
            <div className={styles["tooltip"]} data-arrow={arrowPosition}>
                {content}
            </div>
        </div>
    );
};

export default Tooltip;
